export default __webpack_public_path__ + "static/media/warrior-card.74307c85.png";